import { BannerSlider as BannerSliderBase } from "@omni/components/components/BannerSlider/bannerSlider";
import { BannerSliderProps } from "@omni/types/components/props/bannerSlider.props";
import { BaseStore } from "@omni/types/enums/baseStore.enum";

import { BannerSliderComponent } from "@/components/BannerSlider/bannerSlider.component";

export const BannerSlider = ({
    bannerSlides,
    delay,
    speed,
    trackingProps
}: BannerSliderProps<BaseStore.Etna>) => {
    return (
        <BannerSliderBase
            bannerSlides={bannerSlides}
            delay={delay}
            speed={speed}
            trackingProps={trackingProps}
        >
            <BannerSliderComponent />
        </BannerSliderBase>
    );
};
